import * as React from 'react';
import C from './constants';
import * as helpers from './helpers';
import { CountryRegionData } from './data';
interface ICountryDropdownProps {
	value: string | number,
	name: string,
	id: string,
	classes: string,
	showDefaultOption: boolean,
	defaultOptionLabel: string | number,
	priorityOptions: string[],
	onChange: (value, e) => any,
	onBlur: (e) => any,
	labelType: string,
	valueType: string,
	whitelist: string[],
	blacklist: string[],
	disabled: boolean,
	customOptions: string[]
}
export default class CountryDropdown extends React.Component<ICountryDropdownProps, any> {
	public static defaultProps: Partial<ICountryDropdownProps> = {
		value: '',
		name: 'rcrs-country',
		id: '',
		classes: '',
		showDefaultOption: true,
		defaultOptionLabel: 'Select Country',
		priorityOptions: [],
		onChange: () => null,
		onBlur: () => null,
		labelType: C.DISPLAY_TYPE_FULL,
		valueType: C.DISPLAY_TYPE_FULL,
		whitelist: [],
		blacklist: [],
		customOptions: [],
		disabled: false
	}
	constructor(props) {
		super(props);
		this.state = {
			countries: helpers.filterCountries(CountryRegionData, props.priorityOptions, props.whitelist, props.blacklist)
		};
	}

	public getCountries() {
		const { valueType, labelType } = this.props;

		return this.state.countries.map(({ countryName, countrySlug }) => (
			<option value={(valueType === C.DISPLAY_TYPE_SHORT) ? countrySlug : countryName} key={countrySlug}>
				{(labelType === C.DISPLAY_TYPE_SHORT) ? countrySlug : countryName}
			</option>
		));
	}

	public getDefaultOption() {
		const { showDefaultOption, defaultOptionLabel } = this.props;
		if (!showDefaultOption) {
			return null;
		}
		return (
			<option value="" key="default">{defaultOptionLabel}</option>
		);
	}

	public render() {
		// unused properties deliberately added so arbitraryProps get populated properly
		const { name, id, classes, value, onChange, onBlur, disabled, showDefaultOption, defaultOptionLabel,
			labelType, valueType, whitelist, blacklist, customOptions, priorityOptions, ...arbitraryProps } = this.props;

		const attrs: any = {
			...arbitraryProps,
			name,
			value,
			onChange: (e) => onChange(e.target.value, e),
			onBlur: (e) => onBlur(e),
			disabled
		};
		if (id) {
			attrs.id = id;
		}
		if (classes) {
			attrs.className = classes;
		}

		return (
			<select {...attrs}>
				{this.getDefaultOption()}
				{this.getCountries()}
			</select>
		);
	}
}